/*DTO que almacena la informacion del sitio donde
  se realiza el examen*/
export class SiteApplicationDTO{

    //Constructor de la clase
    constructor(
                //Id del sitio
                public idSitio:number,

                //codigo dane del sitio
                public daneCodeSede:string,

                //Nombre del sitio
                public nombreSede:string,

                //Modalidad en que el sitio imparte sus clases
                public modality:string,

                //codigo saber del sitio
                public saberCode:string){
    }

}
